import { takeEvery } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';
import { authActionCreators } from '..';
import { IState } from '../..';
import { removeAuthLocalStorageValue, setAuthLocalStorageValue } from '../authLocalStorageService';

function* setItOverrides(action: ReturnType<typeof authActionCreators.setItOverrides>) {
  const itOverrides = yield* select((state: IState) => state.auth.itOverridePermissions);
  setAuthLocalStorageValue('auth/itOverridePermissions', itOverrides);

  if (!action.payload.user) {
    removeAuthLocalStorageValue('auth/itOverrideUser');
  }
}

export function* watchSetItOverrides() {
  yield takeEvery(authActionCreators.setItOverrides.match, setItOverrides);
}
